/**
 * Scripts spécifiques à la page carrière.
 */
// Importer les javascripts généraux
import "./main";
import MediaQuery from "./modules/media_query";
// Importer Swiper JS
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
// Importer Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
// Caroussel "cards" de la page carrière
const mediaQuery = new MediaQuery(); // Init l'objet qui permet de déterminer la taille de l'écran
// init Swiper:
const swiperCards = new Swiper('#cards-hr', {
    // configure Swiper to use modules
    modules: [Navigation],
    // Optional parameters
    loop: true,
    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    //Afficher 4 diapos (desktop)
    slidesPerView: mediaQuery.handleScreenChange(),
});
